import { render } from "./DsSelect.vue?vue&type=template&id=5434010c&scoped=true"
import script from "./DsSelect.vue?vue&type=script&lang=js"
export * from "./DsSelect.vue?vue&type=script&lang=js"

import "./DsSelect.vue?vue&type=style&index=0&id=5434010c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5434010c"]])

export default __exports__